import React from 'react';
import styled from 'styled-components';
import { theme } from '../theme';
import Cv from '../images/cv.pdf';

const Bar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 100px;
  height: 92px;
  border-bottom: 2px solid ${theme.border};
  @media (max-width: 700px) {
    padding: 0 24px;
    height: 76px;
  }
`;
const Brand = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
const Mark = styled.div`
  width: 34px;
  height: 34px;
  background: ${theme.accent};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.bg};
  font-family: ${theme.fontDisplay};
  font-size: 15px;
`;
const Name = styled.div`
  font-family: ${theme.fontHeading};
  font-weight: 800;
  font-size: 16px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
`;
const Links = styled.div`
  display: flex;
  gap: 36px;
  font-family: ${theme.fontMono};
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${theme.textMuted};
  @media (max-width: 700px) {
    display: none;
  }
`;

function scrollTo(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
}

export default function Nav() {
  return (
    <Bar>
      <Brand>
        <Mark>Z</Mark>
        <Name>Zaheer Roberts</Name>
      </Brand>
      <Links>
        <span onClick={() => scrollTo('About')} style={{ cursor: 'pointer' }}>About</span>
        <span onClick={() => scrollTo('Work')} style={{ cursor: 'pointer' }}>Work</span>
        <a href={Cv} target="_blank" rel="noopener noreferrer">CV</a>
        <span onClick={() => scrollTo('Contact')} style={{ cursor: 'pointer' }}>Contact</span>
      </Links>
    </Bar>
  );
}
